// libs
import { useDispatch, useSelector } from "react-redux";

// slice actions
import {
  addAlert as addAlertAction,
  remAlert as remAlertAction,
} from "../store/slices/alerts.slice.js";

// constants
import alertTypes from "../constants/alertTypes.js";

export default function useAlert() {
  const { alerts } = useSelector((s) => s.alertsSlice);
  const dispatch = useDispatch();

  const alertDispatch = (msg, type) => {
    const date = new Date();
    const id = date.getTime();
    
    dispatch(addAlertAction({ id: id, msg, type }));

    const removeTimeOut = msg.length * 200;

    setTimeout(() => {
      dispatch(remAlertAction(id));
    }, removeTimeOut);
  };

  const createAlert = {
    info(msg) {
      alertDispatch(msg, alertTypes.INFO);
    },
    success(msg) {
      alertDispatch(msg, alertTypes.SUCCESS);
    },
    error(msg) {
      alertDispatch(msg, alertTypes.ERROR);
    },
    warning(msg) {
      alertDispatch(msg, alertTypes.WARNING);
    },
  };

  return {
    alerts,
    alertTypes,
    createAlert,
  };
}
